import { type GuardArgs } from 'xstate5/dist/declarations/src/guards';

import { type Context, type Event } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfReachedTarget: Guard = ({ context }) => {
  const { programmaticTargetY, scrollOffset, scrollViewDimensions } = context;

  if (programmaticTargetY === null) return true;

  const { contentHeight, viewportHeight } = scrollViewDimensions;

  const scrollY = scrollOffset.value;
  const maxScrollY = contentHeight - viewportHeight;

  const hasReachedTarget = Math.abs(scrollY - programmaticTargetY) < PROGRAMMATIC_SCROLL_THRESHOLD;
  const hasReachedEnd = programmaticTargetY > maxScrollY && scrollY >= maxScrollY - PROGRAMMATIC_SCROLL_THRESHOLD; // prettier-ignore

  return hasReachedTarget || hasReachedEnd;
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfReachedTarget,
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PROGRAMMATIC_SCROLL_THRESHOLD = 2;

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard = (args: GuardArgs<Context, Event>) => boolean;
